 import * as actions from "../actions";
import * as actionsTypes from "../actionTypes";
import {put, takeEvery, all, fork} from "redux-saga/effects";
import CategoryService from '../../services/category.service'


function* getParentCategoryList(action) {
  try {
      const response = yield CategoryService.listCategories(action.payload);
      if (response?.data.statusCode === 200) {
        yield put(actions.getParentCategoryListSuccess(response.data));
      } else {
        yield put(actions.getParentCategoryListFailure("network error"));
      }
    }
    catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    yield put(actions.getParentCategoryListFailure(error));
  }
}

function* getChildCategoryList(action) {
  try {
    if (action.payload) {
      const page = action.payload?.pageNo;
      const perPage = action.payload?.perPage;
      const category = action.payload?.catName;
      const search = action.payload?.search;
      const status = action.payload?.statusType;
      let params = {page, perPage, category, search, status};

      const response = yield CategoryService.listChildCategories(params);
      if (response?.data.statusCode === 200) {
        yield put(actions.getChildCategoryListSuccess(response.data));
      } else {
        yield put(actions.getChildCategoryListFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    yield put(actions.getChildCategoryListFailure(error));
  }
}

function* addCategory(action){
  try {
      let response;
      let payload = action.payload;
      const { title, file, restaurant_branch_id, status } = action.payload;
       // Create FormData object to send file
       const formData = new FormData();
       formData.append('title', title);
       formData.append('restaurant_branch_id', restaurant_branch_id);
       formData.append('file', file);
       formData.append('status', status);
      let create = payload.create;
      delete payload.create;
      if (create) {
        // create user flow
        delete payload._id
      }
      response = yield CategoryService.addCategory(formData);
      if (response?.data.statusCode === 201) {
        yield put(actions.addCategorySuccess(response.data));
      } else {
        yield put(actions.addCategoryFailure("network error"));
      }
    } catch (err) {
      // 
      let error = err?.response?.data?.message;
      if (!error) {
        error = "network error"
      }
      yield put(actions.addCategoryFailure(error));
    }
}

function* updateCategory(action){
  try {
      let payload = action.payload;
      const { title, file, restaurant_branch_id, status } = payload;
      const formData = new FormData();
      formData.append('title', title);
      formData.append('restaurant_branch_id', restaurant_branch_id);
      formData.append('file', file);
      formData.append('status', status);
      const categoryId = payload?._id;
      const response = yield CategoryService.updateCategory(formData,categoryId);//params
      if (response?.data.statusCode === 200) {
        //
        yield put(actions.updateCategorySuccess(response.data));
      } else {
        yield put(actions.updateCategoryFailure("network error"));
      }
    } catch (err) {
      // 
      let error = err?.response?.data?.message;
      if (!error) {
        error = "network error"
      }
      yield put(actions.updateCategoryFailure(error));
    }
}

function* getCategoryLanguage(action){
  try {
    if (action.payload) {
      const response = yield CategoryService.getCategoryLanguage(action.payload);//params
      if (response?.data.statusCode === 200) {
        yield put(actions.getCategoryLanguageSuccess(response.data));
      } else {
        yield put(actions.getCategoryLanguageFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    yield put(actions.getCategoryLanguageFailure(error));
  }
}

function* addCategoryLanguage(action){
  try {
  
      let response;
      let payload = action.payload;
       // Create FormData object to send file
      let create = payload.create;
      delete payload.create;
      
      if (create) {
        // create user flow
        delete payload._id
      }
      response = yield CategoryService.addCategoryLanguage(payload);
      if (response?.data.statusCode === 201) {
        //
        yield put(actions.addCategoryLanguageSuccess(response.data));
      } else {
        yield put(actions.addCategoryLanguageFailure("network error"));
      }
    } catch (err) {
      // 
      let error = err?.response?.data?.message;
      if (!error) {
        error = "network error"
      }
      yield put(actions.addCategoryLanguageFailure(error));
    }
}

function* updateCategoryLanguage(action){
  try {
  
      let response;
      let payload = action.payload;

      const categoryLanguageId = action.payload?._id;
      response = yield CategoryService.updateCategoryLanguage(payload, categoryLanguageId);
      if (response?.data.statusCode === 200) {
        yield put(actions.updateCategoryLanguageSuccess(response.data));
      } else {
        yield put(actions.updateCategoryLanguageFailure("network error"));
      }
    } catch (err) {
      // 
      let error = err?.response?.data?.message;
      if (!error) {
        error = "network error"
      }
      yield put(actions.updateCategoryLanguageFailure(error));
    }
}

function* getParentCategoryListSaga() {
  yield takeEvery(actionsTypes.GET_PARENT_CATEGORY_LIST_START, getParentCategoryList);
}

function* getChildCategoryListSaga() {
  yield takeEvery(actionsTypes.GET_CHILD_CATEGORY_LIST_START, getChildCategoryList);
}

function* addCategorySaga(){
  yield takeEvery(actionsTypes.ADD_CATEGORY_START, addCategory);
}

function* updateCategorySaga(){
  yield takeEvery(actionsTypes.UPDATE_CATEGORY_START, updateCategory);
}

function* getCategoryLanguageSaga(){
  yield takeEvery(actionsTypes.GET_CATEGORY_LANGUAGE_START, getCategoryLanguage);
}

function* addCategoryLanguageSaga(){
  yield takeEvery(actionsTypes.ADD_CATEGORY_LANGUAGE_START, addCategoryLanguage);
}

function* updateCategoryLanguageSaga(){
  yield takeEvery(actionsTypes.UPDATE_CATEGORY_LANGUAGE_START, updateCategoryLanguage);
}

// function* deleteRecordSaga(){
//   yield takeEvery(actionsTypes.DELETE_RESTAURANT_START,deleteRecord);
// }

export function* categorySaga() {
  yield all([fork(getParentCategoryListSaga),fork(getChildCategoryListSaga),fork(addCategorySaga),fork(updateCategorySaga),fork(getCategoryLanguageSaga),fork(addCategoryLanguageSaga),fork(updateCategoryLanguageSaga)]); //,fork(deleteRecordSaga)
}
